module.exports = __webpack_public_path__ + "static/media/cartaz.2115c1c4.png";